import { Component, OnInit } from "@angular/core";
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AutenticacaoService } from 'src/app/services/autenticacao.service';
import { HttpErrorResponse } from '@angular/common/http';
import { finalize } from 'rxjs/operators';
import { Router, ActivatedRoute } from '@angular/router';
import * as RecaptchaModule from 'src/app/services/recaptchaV3.service.js';
import { CommonModule } from "@angular/common";
import { ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { NgxCaptchaModule } from "ngx-captcha";

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css'],
    imports: [ReactiveFormsModule, CommonModule, RouterModule, NgxCaptchaModule],
    providers: [RecaptchaModule.RecaptchaV3Service]
})
export class LoginComponent implements OnInit {

  private recaptchaService = new RecaptchaModule.RecaptchaV3Service();

  form: FormGroup = null;
  loading: boolean = false;

  returnUrl: string = "/logado";

  msgErro: string = null;

  inputSenhaType: string = "password";

  constructor(private autenticacao: AutenticacaoService, private router: Router, private route: ActivatedRoute) {}

  ngOnInit() {

    if(this.route.snapshot.queryParams['returnUrl'] != null){
      this.returnUrl = this.route.snapshot.queryParams['returnUrl'];
     }

    this.form = new FormGroup({
        cpf: new FormControl(null, [Validators.required, Validators.minLength(11)]),
        senha: new FormControl(null, [Validators.required, Validators.minLength(8)]),
        recaptchaV2: new FormControl(null) // , [Validators.required])
    });

    if(this.autenticacao.isAuthenticated()){
      this.router.navigate(['/logado/']);
    }

  }

  async login(){
    let cpf = this.form.get('cpf').value;
    let senha = this.form.get('senha').value;
    const recaptchav2Token = this.form.get('recaptchaV2').value;
    const recaptchaV3Token: string = await this.recaptchaService.genToken('Login');

    this.loading = true;
    this.form.disable();

    this.autenticacao
        .login(cpf, senha, recaptchav2Token, recaptchaV3Token)
        .pipe(
          finalize( () => {
                            this.loading = false;
                            this.form.enable()
                  })
        )
        .subscribe(
          (res: any) => {

            window.location.href =  this.returnUrl;

          },
          (httpError: HttpErrorResponse) => {
            if(httpError.status === 400){
              this.msgErro = httpError.error.ex;

              window.setTimeout(() => {
                this.msgErro = null;
              }, 6000);
            }

        });

  }

  onChangeExibirSenha(value){

    if(value){
      this.inputSenhaType = "text";
    }else{
      this.inputSenhaType = "password";
    }

  }

}
